import { getDateFromValue } from "../../../../../../../../../../utils/date";
import { getWorkflowStageKey } from "../../../../../../../../../../utils/workflow";

export const getDealStageStartEndDate = (
  workflowPhase: string,
  dealDates: Record<string, Record<string, unknown> | null> | undefined
): { startDate?: Date | string; endDate?: Date | string } | undefined => {
  if (!dealDates) {
    return undefined;
  }

  const matchingDealStageEntry = dealDates[getWorkflowStageKey(workflowPhase)];

  if (!matchingDealStageEntry) {
    return undefined;
  }

  return {
    startDate: getDateFromValue(matchingDealStageEntry.startDate) ?? getDateFromValue(matchingDealStageEntry.start),
    endDate: getDateFromValue(matchingDealStageEntry.endDate) ?? getDateFromValue(matchingDealStageEntry.end),
  };
};
